import { render, staticRenderFns } from "./ArticleScrollPage.vue?vue&type=template&id=53b6dfff&scoped=true&"
import script from "./ArticleScrollPage.vue?vue&type=script&lang=js&"
export * from "./ArticleScrollPage.vue?vue&type=script&lang=js&"
import style0 from "./ArticleScrollPage.vue?vue&type=style&index=0&id=53b6dfff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b6dfff",
  null
  
)

export default component.exports